import { Unit } from '../layout/constants'

export const styles = {
  none: 'none',
  hidden: 'hidden',
  dotted: 'dotted',
  dashed: 'dashed',
  solid: 'solid',
  double: 'double',
  groove: 'groove',
  ridge: 'ridge',
  inset: 'inset',
  outset: 'outset',
}

export const width = {
  thin: { unit: Unit.PX, value: 1 },
  medium: { unit: Unit.PX, value: 2 },
  thick: { unit: Unit.PX, value: 4 },
}
